import { useLocation } from "react-router-dom";
import AuthModal from "../components/AuthModal";

/* /login and /register render the SocialPulse-style auth popup over the site. */
export default function Auth() {
  const { pathname } = useLocation();
  return <AuthModal view={pathname === "/register" ? "register" : "signin"} />;
}
